/**************************************************
 * Nombre:       Formulario_Deposito_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, MoneyOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";

const Formulario_Deposito_Ver = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor en USD'} dato={'valor'} {...props}
                                   editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={2} nombre={'Mensaje'} dato={'mensaje'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{textAlign: 'center'}}>Acelara la revision subiendo una captura de pantalla del pago
                        aprobado</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagen dato={'img'} {...props}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Deposito_Ver